import { render } from "./ProductBulkActionButtons.vue?vue&type=template&id=659ec566"
import script from "./ProductBulkActionButtons.vue?vue&type=script&lang=js"
export * from "./ProductBulkActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__